import { Component } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { VorlageFormService } from './vorlage-upload.form.service';
import { BaseEditorComponent, DialogService } from '@schir-int-client/tech';
import { take } from 'rxjs/operators';
import { ChangeFileSuccessDialogComponent } from '../../../../aufgabe/src/lib/aufgaben-in-verfuegung/aufgabe-in-verfuegung/change-file-success-dialog/change-file-success-dialog.component';
import { VorlageFacade } from '@schir-int-client/vorlage-shared';
import { takeUntil, timer } from 'rxjs';

@Component({
	selector: 'schir-int-client-add-vorlage-dialog',
	templateUrl: './add-vorlage-dialog.component.html',
	styleUrls: ['./add-vorlage-dialog.component.scss'],
	providers: [VorlageFormService],
	standalone: false,
})
export class AddVorlageDialogComponent extends BaseEditorComponent {
	constructor(
		private formService: VorlageFormService,
		private dialogService: DialogService,
		private vorlageFacade: VorlageFacade
	) {
		super();
	}

	get form(): UntypedFormGroup {
		return this.formService.form;
	}

	async submit(): Promise<boolean> {
		this.vorlageFacade.changeFileSuccess$.pipe(take(1), takeUntil(timer(20_000))).subscribe(action => {
			this.dialogService.openDialog(ChangeFileSuccessDialogComponent, {
				data: action,
			});
		});
		return this.formService.submit();
	}

	updateVorlage(file: File) {
		this.formService.updateFile(file);
	}
}
